<template>
  <div>
    <el-container>
      <el-main>
        <div class="area">
          <div class="leftNav">
            <el-row class="tac">
              <el-col :span="20">
                <el-menu
                  :router="true"
                  :unique-opened="false"
                  :default-openeds="['1', '2']"
                  background-color="#f7f8fc"
                  :default-active="selectUrl"
                  class="el-menu-vertical-demo"
                  @open="handleOpen"
                  @close="handleClose"
                >
                  <el-menu-item-group>
                    <el-menu-item index="/main/system/system/company"
                      >企业设置</el-menu-item
                    >
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="/main/system/system/contractCompany"
                      >合同公司</el-menu-item
                    >
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="/main/system/system/account"
                      >账号管理</el-menu-item
                    >
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="/main/system/system/rightsGroups"
                      >权限组管理</el-menu-item
                    >
                  </el-menu-item-group>
                  <el-menu-item-group>
                    <el-menu-item index="/main/system/system/orgManage"
                      >组织管理</el-menu-item
                    >
                  </el-menu-item-group>
                </el-menu>
              </el-col>
            </el-row>
          </div>
          <div class="rightNav">
            <router-view></router-view>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      selectUrl: "",
      total: 10,
      pageNo: 1,
      pageSize: 10,
      form: {
        status: "",
        itemName: "",
        itemId: "1",
        company: "",
      },
    };
  },
  created() {
  if (
      this.$route.fullPath.indexOf("/main/system/system/contractCompany") >
        -1 ||
      this.$route.fullPath.indexOf("/main/system/system/contractCompany/seal") >
        -1 ||
      this.$route.fullPath.indexOf("/main/system/system/contractCompany/seal/create") >
        -1 
     
    ) {
      this.selectUrl = "/main/system/system/contractCompany";
    } else {
      this.selectUrl = this.$route.fullPath;
    }
  },
  methods: {
    handleOpen(key, keyPath) {
     
    },
    handleClose(key, keyPath) {
      
    },
    search() {},
    // 重置搜索条件
    reset() {},
    ontypeof() {},
    // 加载指定页面的数据信息
    cur(val) {
      this.pageNo = val;
      // this.loadData();
    },
  },
};
</script>
<style src="../../assets/css/common/nav.less" scoped lang="less"></style>
<style src="../../assets/css/common/operating.less" scoped lang="less"></style>
<style src="../../assets/css/common/table.less" scoped lang="less"></style>
<style src="../../assets/css/common/card.less" scoped lang="less"></style>
<style scoped lang="less">
.el-container {
  height: calc(100vh - 60px);
}
.area {
  display: flex;
  // margin-top: 80px;
  height: 100%;
  // max-width: 1920px;
  // min-width: 1620px;

  .leftNav {
    width: 20%;
    margin-top: 20px;
  }

  .rightNav {
    width: 80%;

    .box {
      display: flex;
      margin-top: 20px;

      .return {
        font-size: 14px;
        color: #409eff;
        margin-right: 20px;
        cursor: pointer;
      }

      .line {
        margin-right: 20px;
        color: #606266;
      }

      .lines {
        margin-right: 20px;
        color: #606266;
        font-weight: bold;
      }

      .contract {
        margin-right: 20px;

        font-size: 14px;
        font-weight: bold;
        color: #606266;
      }
    }
  }
}

.tab_nav[data-v-4d83a540] {
  border-bottom: 0;
}

.filterdiv {
  width: 100%;
  /*margin: 32px 0;*/
  /*padding: 24px 16px 20px;*/
  background-color: #f2f5f8;
  box-sizing: border-box;
  border: 1px solid #d9dbe2;
  border-radius: 6px;

  form {
    display: flex;
    align-items: center;
  }
}

.btn {
  min-width: 110px;
  background-color: transparent;
}

.subbtn {
  background-color: #409eff;
  color: #fff;
}

.row {
  width: 100%;
  display: flex;
  // align-items: center;
  padding-bottom: 16px;

  .label {
    width: 55px;
    min-width: 55px;
    font-size: 14px;
    text-align: right;
    margin-right: 10px;
    margin-top: 6px;
  }
}

.inputdiv {
  width: 100%;
  height: 66px;
  border-top: 1px solid #d9dbe2;
  display: flex;

  .inputs {
    width: 100%;
    display: flex;
    align-items: center;

    .idiv {
      width: 100%;
      display: flex;
      align-items: center;

      .label {
        width: 160px;
        font-size: 12px;
        /*text-align: center;*/
      }

      .input {
        width: 100%;
        height: 34px;
        background-color: #fff;
        border: 1px solid #d9dbe2;
        border-radius: 6px;
        padding-right: 24px;
        padding-left: 10px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;

        i {
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -6px;
        }
      }
    }
  }

  .btns {
    min-width: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;

    button {
      min-width: 84px;
    }
  }
}

.input > .in_boxs {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.in_boxs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .in_box {
    width: auto;
    display: flex;
    align-items: center;
    height: 22px;
    background-color: #409eff;
    color: #fff;
    padding: 0 7px;
    border-radius: 4px;
    margin-right: 10px;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .text {
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    margin-right: 8px;
  }

  span {
    cursor: pointer;
    font-size: 18px;
  }
}

.centerNav {
  width: 100%;
  display: flex;
  justify-content: space-between;

  .centerBtn {
    margin-top: 10px;

    button {
      margin-left: 10px;
    }
  }
}

.nav {
  font-weight: bold;
  color: #303140;
}

.el-menu-item.is-active {
  border-left: 4px solid #6669e3;
  color: #6669e3;
  margin-left: -2px;
  background-color: #eceef4;
}

.demo-block.demo-menu .el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 152px;
  min-height: 400px;
}

.el-submenu .el-menu-item {
  min-width: 0;
}

.el-form--inline .el-form-item {
  margin: 8px 0 8px 8px;
}

.el-form-item {
  margin: 0;
}
.el-menu-item {
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
  height: 40px;
  color: #303140;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
  box-sizing: border-box;
}
.el-menu-item:hover {
  outline: 0 !important;
  background-color: #eceef4 !important;
}
.el-menu {
   border-right: 0;
  
}
</style>